import { InputAdornment, InputAdornmentProps } from '@mui/material'
import React from 'react'

const InputAdornmentWrapper: React.FC<InputAdornmentProps> = ({ ...props }) => (
  <InputAdornment {...props} />
)

export default InputAdornmentWrapper
